import { render, staticRenderFns } from "./PatientRelationInsOnlySelect.vue?vue&type=template&id=4e4b829e&"
import script from "./PatientRelationInsOnlySelect.vue?vue&type=script&lang=ts&"
export * from "./PatientRelationInsOnlySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports